import { AppBar, Button, Dialog, DialogContent, Icon, IconButton, Toolbar, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { useState } from "react"
import AgGridTable from "../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import moment from "moment";
import jwtDecode from "jwt-decode";
import { HideShowCommentPopup } from "./GroupRowInnerRenderer";

const ShowComments = (props) => {
    const [open, setOpen] = useContext(HideShowCommentPopup);
    const [showAll, setShowAll] = useState(false);
    const [allComments, setAllComments] = useState([]);
    const [lastComments, setLastComments] = useState([]);
    const [users, setUsers] = useState([]);
    const okrUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.okrs}`;
    const valueFormatter = (props) => {
        if(props.value){
            return moment(props.value).format('DD-MM-YYYY')
        }else{
            return '';
        }
    }
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
    const roleMDHR = token?.scope && token?.scope.includes('ROLE_MD') || token?.scope?.includes('ROLE_HR');

    const [columnDefs, setColumnDefs] = useState([
        { field: 'objectiveValue', rowGroup: true, hide: true },
        { field: 'keyResultValue', rowGroup: true, hide: true },
        { field: 'comment' ,minWidth: 350},
        { field: 'status' },
        { field: 'weekNo' },
        { field: 'updateNo' },
        { field: 'startDate', valueFormatter: valueFormatter },
        { field: 'endDate', valueFormatter: valueFormatter },
        { field: 'createdBy' },
    ])

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
        }
    }, [props.open]);

    function diff_weeks(dt2, dt1) {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24 * 7);
        return Math.abs(Math.round(diff));
    }

    const addWeeksToDate = (dateObj, numberOfWeeks) => {
        dateObj.setDate(dateObj.getDate() + numberOfWeeks * 7);
        return dateObj;
    }

    const getOkr = async (id) => {
        const okr = await OAuthService.getEditData(okrUrl, id);
        let all = [...allComments];
        const latest = [...lastComments];

        if (okr?.data) {
            if (okr?.data?.objective.length > 0) {
                const getTotalWeeks = diff_weeks(new Date(okr?.data?.startDate), new Date(okr?.data?.endDate));
                const duration = okr?.data?.weekDuration || 3;
                
                let weekstartDate = moment(new Date(okr?.data?.startDate)).format('YYYY-MM-DD')
                let weekendDate = moment(addWeeksToDate(new Date(okr?.data?.startDate), duration)).format('YYYY-MM-DD')
                const chunks = []
                for (let i = 0; i <= getTotalWeeks; i += duration) {
                  const startWeek = moment(weekstartDate).week();
                  const endWeek = moment(weekendDate).week()
                  const week = (startWeek + '-' + endWeek).toString();
                  chunks.push({ startDate: weekstartDate, endDate: weekendDate, weeks: week })
                  weekstartDate = moment(weekendDate).add(1, 'days').format('YYYY-MM-DD');
                  weekendDate = moment(addWeeksToDate(new Date(weekstartDate), duration)).format('YYYY-MM-DD')
                  if (addWeeksToDate(new Date(weekstartDate), duration) > new Date(okr?.data?.endDate)) {
                    weekendDate = moment(new Date(okr?.data?.endDate)).format('YYYY-MM-DD')
                  }
                }
                const currentdate = new Date();
                let updateNumber = chunks.findIndex((val) => currentdate >= new Date(val.startDate) && currentdate <= new Date(val.endDate));
                let getCurrentUpdateNumber = updateNumber >= 0 ? updateNumber + 1 : 1;

                okr?.data.objective.map((obj) => {
                    let objects = {
                        objectiveValue: obj.objectiveValue
                    }
                    if (obj?.keyResult.length > 0) {
                        obj?.keyResult.map((result) => {
                            objects = { ...objects, keyResultValue: result.keyResultValue }
                            if (result?.keyResultStatus.length > 0) {
                                result?.keyResultStatus.map((status) => {
                                    const name = users.filter((user) => user.email === status?.createdBy);
                                    if (name.length > 0) {
                                        status.createdBy = name[0].fullname
                                    }
                                    if(okr?.data.isDraft && getCurrentUpdateNumber === status.updateNo && roleMDHR){
                                        
                                    }else{
                                        objects = { ...objects, ...status }
                                        all.push(objects)
                                        all.reverse()
                                    }
                                })
                                latest.push(objects)
                            }
                        })
                    }
                })
            }
        }
        setLastComments(latest)
        setAllComments(all);
    }

    useEffect(() => {
        if (props.id && users.length > 0) {
            getOkr(props.id)
        }

    }, [props.id, users])

    useEffect(() => {
        const users = async () => {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

            try {

                const user = await OAuthService.getList(url);
                if (user.data) {
                    const list = user?.data?._embedded?.users.map((data) => {
                        return { email: data.email, fullname: data?.firstName + ' ' + data?.lastName }
                    })
                    setUsers(list)
                }
            } catch (error) {

            }
        }
        users()
    }, [])

    return (
        <>
            <Dialog
                open={open}
                // onClose={handleCommentsMsg}
                maxWidth="lg"
                fullWidth={true}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Update's history
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setOpen(false)}
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Toolbar className="flex w-full justify-end">
                        {showAll ? <Button
                                variant="contained"
                                color="warning"
                                onClick={() => setShowAll(false)}
                            >
                                Load Latest updates
                            </Button>
                        : <Button
                                variant="contained"
                                color="warning"
                                onClick={() => setShowAll(true)}
                            >
                                Load All updates
                            </Button>}
                    </Toolbar>
                    <div className="h-[400px]">
                        <AgGridTable
                            rowData={showAll ? allComments : lastComments}
                            columnDefs={columnDefs}
                            editable={false}
                            groupDefaultExpanded={2}
                            groupDisplayType={'groupRows'}
                            hideCheckbox={true}
                            floatingFilter={false}
                        />
                    </div>

                </DialogContent>
            </Dialog>
        </>
    )

}
export default ShowComments